export { WideCalculator } from './WideCalculator';
